import React, { useState } from "react";
import { UploadButton } from "@presentation/components/helpers/UploadButton";
import { UploadRawFilesDialog } from "@presentation/components/inventory/components/UploadRawFilesDialog";
import { useUploadStore } from "@presentation/stores/UploadStore";
import type { UploadDestination } from "@presentation/components/uploadDestination/UploadDestinationPickerDialog";

interface UploadRawFilesButtonProperties {
  onUploadSuccess?: () => void;
  projectId: string;
  initialDestination?: Partial<UploadDestination>;
}

export const UploadRawFilesButton: React.FC<UploadRawFilesButtonProperties> = ({ onUploadSuccess, projectId, initialDestination }) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const { activeUploads } = useUploadStore();
  const uploadingCount = Object.values(activeUploads).filter((u) => (u.status === "uploading" || u.status === "pending") && (u.type === "rawFile" || u.type === undefined)).length;

  return (
    <>
      <UploadButton projectId={projectId} onClick={() => setIsDialogVisible(true)} title="Upload Raw Files" uploadingCount={uploadingCount} />

      {isDialogVisible && (
        <UploadRawFilesDialog
          key={projectId}
          projectId={projectId}
          initialDestination={initialDestination}
          onClose={() => setIsDialogVisible(false)}
          onUploadStarted={() => {
            // Keep the dialog open so the user can see the progress of what they just started
          }}
          onUploadSuccess={onUploadSuccess}
        />
      )}
    </>
  );
};
